import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=8cb07ee0&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=8cb07ee0&prod&lang=scss&"
import style1 from "./Index.vue?vue&type=style&index=1&id=8cb07ee0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cb07ee0",
  null
  
)

export default component.exports